import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Section from '../common/Section';
import Image from '../common/Image';
import styles from '../../styles/modules/components/category-list.module.scss';
import { getStaticPath } from "../../utils";



interface CategoryListProps {
    list: {
        img: string,
        title: string,
        plan: string,
        url: string
    }[],
    onItemClick: (value) => void

}

interface ListJSXProps {
    img: string,
    title: string,
    plan: string,
    index: any,
    url: string
    onItemClick: (value) => void
}



const CategoryList = (props: CategoryListProps) => {
    const { list, onItemClick } = props;
    const [small_screen, setLyaout] = useState(true);
    useEffect(() => {
        window.innerWidth > 992 ? setLyaout(false) : setLyaout(true);
        window.addEventListener('resize', (e) => {
            if (window.innerWidth > 992) {
                small_screen ? setLyaout(!small_screen) : '';
            }
            else {
                !small_screen ? setLyaout(!small_screen) : '';
            }
        });
    });
    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        arrows: false,
        rows: 2,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };
    return (
        <Section className={`${styles.category} category-list`}>
            {
                <div className={`${styles._container} container`}>
                    <div className="slider-wrap">
                        <Slider className={styles._carosel} {...settings}>
                            {
                                list.map !== undefined && list.map((item, index) => {
                                    return (
                                        <ListJSX key={index + '1'} index={index} {...item} onItemClick={onItemClick} />
                                    )
                                })
                            }
                        </Slider>
                    </div>
                </div>
                // :
                // <div className="container">
                //     <div className="row">
                //         {
                //             list.map !== undefined && list.map((cat: any, index) => {
                //                 return (
                //                     <div className={`${styles._col} col-lg-3 col-xl-3`} key={index}>
                //                         <ListJSX {...cat} index={index} onItemClick={onItemClick} />
                //                     </div>
                //                 )
                //             })
                //         }
                //     </div>
                // </div>
            }

        </Section>
    );
}



const ListJSX = (props: ListJSXProps) => (
    <a key={props.index} className={styles._item} href="#" onClick={(e) => {
        e.preventDefault();
        props.onItemClick(props);
    }} title={props.title} data-item={props.title}>
        <div className={styles._img}>
            <Image src={getStaticPath(`/static/images/home/feature/${props.img}`||'')} quality={100} alt={props.title} width="60" height="60" unoptimized={true}/>
        </div>
        <div className={styles._text}>
            <p> {props.title}</p>
            <p> {props.plan} </p>
        </div>

    </a>
);


export default CategoryList;
